import { cn } from "@/shared/lib";

type AbilityGlyphProps = {
  name: string;
  iconUrl: string | null;
  ultimate: boolean;
  size?: number;
  // Подпись для экранного диктора там, где названия рядом нет (лента прокачки на телефоне).
  label?: string;
  className?: string;
};

// Значок умения, как в игре: белый знак на тёмной плашке, у ульты — золотая рамка. Других
// иконок умений в справочнике игры нет (`/v1/assets/items`, 137 px).
export const AbilityGlyph = ({
  name,
  iconUrl,
  ultimate,
  size = 30,
  label,
  className,
}: AbilityGlyphProps) => {
  const glyph = Math.round(size * 0.72);
  return (
    <span
      style={{ width: size, height: size, borderRadius: Math.round(size / 4) }}
      className={cn(
        "inline-flex shrink-0 items-center justify-center bg-[radial-gradient(circle_at_50%_35%,var(--color-sidebar-active),var(--color-surface-sunken))]",
        ultimate ? "border-2 border-accent" : "border border-border-strong",
        className,
      )}
    >
      {iconUrl === null ? (
        // Без иконки — первая буква; рядом с названием она лишняя для экранного диктора.
        <span
          role={label === undefined ? undefined : "img"}
          aria-label={label}
          aria-hidden={label === undefined ? true : undefined}
          className="text-[11px] text-muted"
        >
          {name.slice(0, 1)}
        </span>
      ) : (
        <img
          src={iconUrl}
          alt={label ?? ""}
          width={glyph}
          height={glyph}
          loading="lazy"
          style={{ width: glyph, height: glyph }}
          className="object-contain"
        />
      )}
    </span>
  );
};
